



























































































































import {
  defineComponent,
  useFetch,
  useContext,
  useMeta,
  ref,
  computed,
  onUpdated,
  useRoute,
  nextTick,
} from '@nuxtjs/composition-api'
import { useBreadcrumb } from '~/composables/ui/useBreadcrumb'
import { useHeaderHeight } from '~/composables/ui/useHeaderHeight'
import { useBrand } from '~/composables/useBrand'
import { useBreadcrumbsSchemaScript } from '~/composables/useSchemaScript'
import { sortAndGroupByAlphabet } from '~/lib/utilities'
import { Brand } from '~/types/brand'

enum ViewMode {
  List = 'list',
  Image = 'image',
}

interface GroupedBrand {
  alphabet: string
  record: Brand[]
}

export default defineComponent({
  name: 'PagesBrand',

  setup() {
    const { loading, brands, getBrands } = useBrand()
    const groupedBrands = computed(
      () => sortAndGroupByAlphabet(brands.value, 'name') as GroupedBrand[]
    )
    const logoBrands = computed(() =>
      brands.value?.filter((brand) => brand.img)
    )

    useFetch(getBrands)

    const { i18n } = useContext()
    const { breadcrumbs, setBreadcrumbs } = useBreadcrumb()
    setBreadcrumbs([
      {
        label: i18n.t('brand.title') as string,
      },
    ])

    const { breadcrumbsSchemaScript, setBreadcrumbsSchemaScript } =
      useBreadcrumbsSchemaScript()
    setBreadcrumbsSchemaScript(breadcrumbs.value!)

    useMeta(() => {
      return breadcrumbsSchemaScript.value
        ? {
            script: [breadcrumbsSchemaScript.value],
          }
        : {}
    })

    const viewOptions = [
      {
        type: ViewMode.List,
        label: 'Lijst',
        icon: 'list',
      },
      {
        type: ViewMode.Image,
        label: "Logo's",
        icon: 'image',
      },
    ]

    const viewMode = ref(ViewMode.Image)
    const switchViewMode = (type: ViewMode) => {
      viewMode.value = type
    }

    const { scrolledHeight: scrolledHeaderHeight } = useHeaderHeight(true)

    const route = useRoute()
    const shouldScrollToHash = ref(!!route.value.hash)

    onUpdated(() => {
      nextTick(() => {
        if (!shouldScrollToHash.value) return
        const el = window.document.querySelector(
          `a[href='${route.value.hash}']`
        )
        if (el) {
          ;(el as typeof el & { click: () => void }).click()
          shouldScrollToHash.value = false
        }
      })
    })

    return {
      loading,
      brands,
      logoBrands,
      groupedBrands,
      viewMode,
      ViewMode,
      viewOptions,
      scrolledHeaderHeight,

      switchViewMode,
    }
  },

  head: {},
})
